import React, { useRef } from 'react';
import { Search, ArrowRight } from 'lucide-react';
import { IDX_SEARCH_URL } from '../../constants/site';
import { useIdxAddonsScript } from '../../hooks/useIdxAddonsScript';

const FallbackCta = () => (
  <div className="rounded-2xl bg-white border border-gold-200 shadow-xl p-8 sm:p-10 text-center" data-testid="idx-fallback-cta">
    <h3 className="text-xl sm:text-2xl font-serif font-bold text-[#143160] mb-2">Search Every Active Listing on the MLS</h3>
    <p className="text-sm sm:text-base text-gray-600 max-w-lg mx-auto mb-6">
      Browse live Virginia Beach, Hampton Roads and Outer Banks homes on Swell Realty's MLS portal, updated around the clock straight from the REIN MLS.
    </p>
    <a
      href={IDX_SEARCH_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="idx-fallback-search-link"
      className="inline-flex items-center space-x-2 bg-gradient-to-r from-gold-400 to-gold-500 hover:from-gold-500 hover:to-gold-600 text-[#143160] px-8 py-4 rounded-full font-bold text-lg shadow-lg hover:scale-105 transition-all"
    >
      <Search className="w-5 h-5" />
      <span>Search the Swell MLS Portal</span>
      <ArrowRight className="w-5 h-5" />
    </a>
  </div>
);

// Mount point for the IDX Addons live search tool. Falls back to a direct MLS CTA
// if the script errors (unauthorized domain) or never renders.
export const IdxWidgetContainer = () => {
  const containerRef = useRef(null);
  const status = useIdxAddonsScript(containerRef);

  return (
    <div className="max-w-3xl mx-auto" data-testid="idx-widget-wrapper" data-status={status}>
      <div
        id="idx-widget-container"
        ref={containerRef}
        data-testid="idx-widget-container"
        className={status === 'failed' ? 'hidden' : 'bg-white rounded-2xl shadow-xl p-3 min-h-[72px] text-left'}
      />
      {status === 'loading' && (
        <div className="mt-3 flex items-center justify-center space-x-2 text-xs text-gray-400" data-testid="idx-widget-loading" aria-live="polite">
          <span className="w-2 h-2 rounded-full bg-gold-400 animate-pulse" />
          <span>Loading live MLS search…</span>
        </div>
      )}
      {status === 'failed' && <FallbackCta />}
    </div>
  );
};
